var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from "react";
var ReasonSelection = function (_a) {
    //
    var options = _a.options, _b = _a.placeholder, placeholder = _b === void 0 ? "Select an option" : _b, selected = _a.selected, onChange = _a.onChange;
    var _c = __read(useState(false), 2), open = _c[0], setOpen = _c[1];
    var dropdownRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, []);
    return (React.createElement("div", { className: "reject-reason-selection-container", ref: dropdownRef },
        React.createElement("div", { className: "reject-reason-selection ".concat(open && "active"), onClick: function () { return setOpen(function (prev) { return !prev; }); } },
            React.createElement("p", null, (selected === null || selected === void 0 ? void 0 : selected.label) || placeholder),
            React.createElement("span", { className: "dropdown-icon" },
                React.createElement("i", { className: open ? "edel-icon-arrow-up" : "edel-icon-arrow-down" }))),
        open && (React.createElement("ul", { className: "reject-dropdown-list" }, options.map(function (item) { return (React.createElement("li", { key: item.value, className: "reject-dropdown-item", onClick: function () {
                onChange(item);
                setOpen(false);
            } }, item.label)); })))));
};
export default ReasonSelection;
